import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-alert-atencao-padrao',
    templateUrl: './alert-atencao-padrao.component.html',
    styleUrls: ['./alert-atencao-padrao.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class AlertAtencaoPadraoComponent {
  @Input() showAlerta: boolean;
  @Input() descricaoAlerta: any;
  @Input() tituloAlerta: any;
  @Output() alertaCancelou = new EventEmitter();
  @Output() alertaConfirmou = new EventEmitter();

  constructor() { }

  fechouAlerta() {
    this.alertaCancelou.emit(true);
  }

  confirmaAlerta() {
    this.alertaConfirmou.emit(true);

  }
}
